module.exports = __webpack_public_path__ + "static/media/mechanics.4ef735fd.png";